define(["require", "exports", "tslib", "@arcgis/core/geometry/Point", "@arcgis/core/geometry/Polygon", "@arcgis/core/geometry/Polyline", "@arcgis/core/layers/GraphicsLayer", "@arcgis/core/rest/query", "@arcgis/core/rest/support/Query", "@arcgis/core/widgets/Sketch/SketchViewModel", "mobx-react", "react", "../model/services/EventManager", "../store/RouteStore", "../store/StoreManager", "../utils/EntityUtil", "../utils/GeometryUtil", "../utils/MapUtil", "../utils/SpatialReferenceFactory", "./blocks"], function (require, exports, tslib_1, Point_1, Polygon_1, Polyline_1, GraphicsLayer_1, query, Query_1, SketchViewModel_1, mobx_react_1, React, EventManager_1, RouteStore_1, StoreManager_1, EntityUtil_1, GeometryUtil_1, MapUtil_1, SpatialReferenceFactory_1, blocks_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EntityCreateByGeometryView = void 0;
    Point_1 = tslib_1.__importDefault(Point_1);
    Polygon_1 = tslib_1.__importDefault(Polygon_1);
    Polyline_1 = tslib_1.__importDefault(Polyline_1);
    GraphicsLayer_1 = tslib_1.__importDefault(GraphicsLayer_1);
    query = tslib_1.__importStar(query);
    Query_1 = tslib_1.__importDefault(Query_1);
    SketchViewModel_1 = tslib_1.__importDefault(SketchViewModel_1);
    React = tslib_1.__importStar(React);
    let EntityCreateByGeometryView = exports.EntityCreateByGeometryView = class EntityCreateByGeometryView extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "draw", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onDrawComplete", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "resultGraphics", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "drawGraphics", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "featureSelectionQuery", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "cancel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.deactiveDrawTool();
                    (0, RouteStore_1.openRoute)({ pathname: "/tasks" });
                }
            });
            Object.defineProperty(this, "reset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.setState({
                        enableSave: false
                    });
                    this.deactiveDrawTool();
                    this.resultGraphics.removeAll();
                    this.drawGraphics.removeAll();
                }
            });
            Object.defineProperty(this, "save", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    var _a;
                    this.deactiveDrawTool();
                    this.setState({
                        enableSave: false
                    });
                    let results = this.resultGraphics.graphics.toArray();
                    if (this.props.enableMultipartFeatureCapture) {
                        if (this.props.returnCapturedFeaturesAsSingleGeometry) {
                            if (results.length > 0) {
                                (0, EventManager_1.notify)("Unioning Geometries");
                                GeometryUtil_1.GeometryUtil.union(this.props.configStore.geometryServiceUrl, (0, MapUtil_1.graphicsToGeometryArray)(this.resultGraphics))
                                    .then((unioned) => {
                                    (0, RouteStore_1.openRoute)({
                                        type: "replace",
                                        pathname: this.props.returnRoute,
                                        state: {
                                            attributes: results.map(g => g.attributes),
                                            geometry: unioned.toJSON()
                                        }
                                    });
                                })
                                    .catch(err => {
                                    throw err;
                                });
                            }
                            else {
                                throw new Error("Unable to union geometries. Empty geometry array provided");
                            }
                        }
                        else {
                            (0, RouteStore_1.openRoute)({
                                type: "replace",
                                pathname: this.props.returnRoute,
                                state: {
                                    geometry: (0, MapUtil_1.graphicsToGeometryArray)(this.resultGraphics).map(x => x.toJSON()),
                                    attributes: results.map(g => g.attributes)
                                }
                            });
                        }
                    }
                    else {
                        if (results.length === 1) {
                            (0, RouteStore_1.openRoute)({
                                type: "replace",
                                pathname: this.props.returnRoute,
                                state: {
                                    geometry: (0, MapUtil_1.graphicsToGeometryArray)(this.resultGraphics)[0].toJSON(),
                                    attributes: (_a = results[0].attributes) !== null && _a !== void 0 ? _a : {}
                                }
                            });
                        }
                        else {
                            throw new Error("Invalid number of geometries have been digitised");
                        }
                    }
                }
            });
            Object.defineProperty(this, "initiateDrawGeometryOperation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.deactiveDrawTool();
                    if (this.props.geometryTypeToCapture === "Point") {
                        this.activateDrawTool("point", this.onDrawFinished);
                    }
                    else if (this.props.geometryTypeToCapture === "Polygon") {
                        this.activateDrawTool("polygon", this.onDrawFinished);
                    }
                    else {
                        throw new Error("Unsupported Geometry Type");
                    }
                }
            });
            Object.defineProperty(this, "onDrawFinished", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    this.deactiveDrawTool();
                    this.addGeometryToResultsLayer(e.clone());
                }
            });
            Object.defineProperty(this, "onSelectByDrawFinished", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    this.deactiveDrawTool();
                    if (e.geometry) {
                        if (e.geometry instanceof Polygon_1.default && e.geometry.isSelfIntersecting) {
                            this.props.modalStore.createInfoModal("Invalid Geometry", React.createElement("p", null, "Please reset your selection and draw an area of interest on the map that does not overlap (self-intersect) itself"));
                        }
                        else {
                            this.featureSelectionQuery.geometry = e.geometry;
                            query.executeQueryJSON(this.props.selectionLayerQueryUrl, this.featureSelectionQuery).then(featureSet => {
                                this.drawGraphics.removeAll();
                                if (featureSet.features.length > 0) {
                                    for (const selected of featureSet.features) {
                                        let isNewSelection = true;
                                        for (const existing of this.resultGraphics.graphics.toArray()) {
                                            if ((0, EntityUtil_1.getGraphicAttribute)(existing, "OBJECTID") == (0, EntityUtil_1.getGraphicAttribute)(selected, "OBJECTID")) {
                                                isNewSelection = false;
                                                break;
                                            }
                                        }
                                        if (isNewSelection) {
                                            this.addGeometryToResultsLayer(selected);
                                        }
                                    }
                                }
                            }).catch(err => {
                                throw new Error("Feature selection query failed" + err.message);
                            });
                        }
                    }
                }
            });
            this.resultGraphics = new GraphicsLayer_1.default({ id: "createEntityResultGraphics" });
            props.mapStore.Map.map.layers.add(this.resultGraphics);
            this.drawGraphics = new GraphicsLayer_1.default({ id: "createEntityDrawGraphics" });
            props.mapStore.Map.map.layers.add(this.drawGraphics);
            this.state = {
                enableSave: false
            };
            if (this.props.enableFeatureCaptureBySelection) {
                this.createSelectionLayerQueryTask();
            }
        }
        componentDidMount() {
            this.draw = new SketchViewModel_1.default({
                view: this.props.mapStore.Map,
                layer: this.drawGraphics,
                pointSymbol: MapUtil_1.EDIT_POINT_SYMBOL,
                polylineSymbol: MapUtil_1.EDIT_POLYLINE_SYMBOL,
                polygonSymbol: MapUtil_1.EDIT_POLYGON_SYMBOL,
                updateOnGraphicClick: false
            });
            if (this.props.enableSelectFeaturesByPolyline) {
                this.initiateSelectTemplateGeometryByPolylineDrawOperation();
            }
            else if (this.props.enableSelectFeaturesByRadius) {
                this.initiateSelectTemplateGeometryByRadiusDrawOperation();
            }
            else if (this.props.enableSelectFeaturesByPoint) {
                this.initiateSelectTemplateGeometryByPointDrawOperation();
            }
            else if (this.props.enableSelectFeaturesByPolygon) {
                this.initiateSelectTemplateGeometryByPolygonDrawOperation();
            }
            else if (this.props.enableFeatureCaptureByDrawing) {
                this.initiateDrawGeometryOperation();
            }
        }
        componentWillUnmount() {
            this.deactiveDrawTool();
            this.draw.destroy();
            this.props.mapStore.Map.map.remove(this.resultGraphics);
            this.props.mapStore.Map.map.remove(this.drawGraphics);
        }
        activateDrawTool(drawMode, onComplete) {
            this.draw.create(drawMode);
            this.onDrawComplete = this.draw.on("create", res => {
                if (res.state == "complete") {
                    onComplete(res.graphic);
                }
            });
        }
        deactiveDrawTool() {
            var _a;
            (_a = this === null || this === void 0 ? void 0 : this.onDrawComplete) === null || _a === void 0 ? void 0 : _a.remove();
            this.draw.cancel();
        }
        render() {
            const canSave = this.state.enableSave;
            return (React.createElement(blocks_1.VGroup, null,
                React.createElement(blocks_1.Header, { title: `Create ${this.props.userFriendlyDescOfEntityBeingCaptured}` },
                    React.createElement(blocks_1.HGroup, null,
                        React.createElement(blocks_1.HeaderButton, { label: "Accept", disabled: !canSave, onClick: this.save }),
                        React.createElement(blocks_1.HeaderButton, { label: "Reset", disabled: !canSave, onClick: this.reset }),
                        React.createElement(blocks_1.HeaderButton, { label: "Cancel", color: "secondary", onClick: this.cancel }))),
                React.createElement(blocks_1.VGroup, { className: "form", style: { alignItems: "flex-start" } },
                    !canSave
                        ? React.createElement(blocks_1.HGroup, { style: { marginBottom: '10px' } },
                            React.createElement("div", null, this.getLabel()),
                            React.createElement(blocks_1.Tooltip, { text: this.getToolTip() }))
                        : React.createElement("div", { style: { marginBottom: '10px' } }, "Click Accept, Reset or Cancel from the menu to continue."),
                    this.renderDrawOptions())));
        }
        createSelectionLayerQueryTask() {
            this.featureSelectionQuery = new Query_1.default();
            this.featureSelectionQuery.returnGeometry = true;
            this.featureSelectionQuery.spatialRelationship = "intersects";
            this.featureSelectionQuery.outSpatialReference = SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994;
            this.featureSelectionQuery.where = this.props.selectionLayerQueryFilter;
            const outputFields = [];
            for (const field of this.props.selectionLayerQueryOutputFields.split(",")) {
                outputFields.push(field);
            }
            this.featureSelectionQuery.outFields = outputFields;
        }
        initiateSelectTemplateGeometryByRadiusDrawOperation() {
            this.deactiveDrawTool();
            this.activateDrawTool("circle", this.onSelectByDrawFinished);
        }
        initiateSelectTemplateGeometryByPointDrawOperation() {
            this.deactiveDrawTool();
            this.activateDrawTool("point", this.onSelectByDrawFinished);
        }
        initiateSelectTemplateGeometryByPolylineDrawOperation() {
            this.deactiveDrawTool();
            this.activateDrawTool("polyline", this.onSelectByDrawFinished);
        }
        initiateSelectTemplateGeometryByPolygonDrawOperation() {
            this.deactiveDrawTool();
            this.activateDrawTool("polygon", this.onSelectByDrawFinished);
        }
        addGeometryToResultsLayer(g) {
            if (g.geometry instanceof Point_1.default) {
                g.symbol = MapUtil_1.EDIT_POINT_SYMBOL;
            }
            else if (g.geometry instanceof Polyline_1.default) {
                g.symbol = MapUtil_1.EDIT_POLYLINE_SYMBOL;
            }
            else if (g.geometry instanceof Polygon_1.default) {
                g.symbol = MapUtil_1.EDIT_POLYGON_SYMBOL;
            }
            this.resultGraphics.add(g);
            this.setState({
                enableSave: true
            });
        }
        getLabel() {
            if (this.props.enableFeatureCaptureBySelection &&
                !this.props.enableFeatureCaptureByDrawing) {
                return ("Using the map, define the new " +
                    this.props.userFriendlyDescOfEntityBeingCaptured +
                    " by selecting " +
                    (this.props.enableMultipartFeatureCapture
                        ? "one or more " +
                            this.pluraliseNoun(this.props.userFriendlyDescOfSelectableMapFeatures)
                        : "a " +
                            this.props.userFriendlyDescOfSelectableMapFeatures));
            }
            else {
                return ("Using the map, digitise a " +
                    this.props.userFriendlyDescOfEntityBeingCaptured);
            }
        }
        getToolTip() {
            if (this.props.enableFeatureCaptureBySelection) {
                if (!this.props.enableFeatureCaptureByDrawing) {
                    return ("Using the map, select " +
                        (this.props.enableMultipartFeatureCapture
                            ? "one or more " +
                                this.pluraliseNoun(this.props.userFriendlyDescOfSelectableMapFeatures)
                            : "a " +
                                this.props.userFriendlyDescOfSelectableMapFeatures) +
                        " by digitising an area of interest. " +
                        this.pluraliseNoun(this.props.userFriendlyDescOfSelectableMapFeatures) +
                        " that intersect your area of interest will be selected.");
                }
                else {
                    return ("Using the map, digitise the required " +
                        this.props.userFriendlyDescOfEntityBeingCaptured +
                        ". You may achieve this task by either drawing a " +
                        this.props.userFriendlyDescOfEntityBeingCaptured +
                        " on the map, or by selecting one or more " +
                        this.pluraliseNoun(this.props.userFriendlyDescOfSelectableMapFeatures) +
                        " to represent the " +
                        this.props.userFriendlyDescOfEntityBeingCaptured +
                        ". Once this task is complete, you can further refine the digitised " +
                        this.props.userFriendlyDescOfEntityBeingCaptured);
                }
            }
            else {
                return ("Using the map, digitise the required " +
                    this.props.userFriendlyDescOfEntityBeingCaptured +
                    ".");
            }
        }
        pluraliseNoun(noun) {
            if (noun.charAt(noun.length - 1) === "y") {
                return noun.substr(0, noun.length - 1) + "ies";
            }
            else {
                return noun + "s";
            }
        }
        renderDrawOptions() {
            if (this.props.enableMultipartFeatureCapture ||
                (!this.props.enableMultipartFeatureCapture &&
                    this.resultGraphics.graphics.toArray().length < 1)) {
                const drawOptions = [];
                if (this.props.enableFeatureCaptureBySelection) {
                    if (this.props.enableSelectFeaturesByPolyline) {
                        drawOptions.push(React.createElement(blocks_1.CtaButton, { key: drawOptions.length, label: `Select ${this.props.userFriendlyDescOfEntityBeingCaptured} Feature(s) By Line`, color: "primary", onClick: this.initiateSelectTemplateGeometryByPolylineDrawOperation.bind(this) }));
                    }
                    if (this.props.enableSelectFeaturesByRadius) {
                        drawOptions.push(React.createElement(blocks_1.CtaButton, { key: drawOptions.length, label: `Select ${this.props.userFriendlyDescOfEntityBeingCaptured} Feature(s) By Radius`, color: "primary", onClick: this.initiateSelectTemplateGeometryByRadiusDrawOperation.bind(this) }));
                    }
                    if (this.props.enableSelectFeaturesByPoint) {
                        drawOptions.push(React.createElement(blocks_1.CtaButton, { key: drawOptions.length, label: `Select ${this.props.userFriendlyDescOfEntityBeingCaptured} Feature(s) By Point`, color: "primary", onClick: this.initiateSelectTemplateGeometryByPointDrawOperation.bind(this) }));
                    }
                    if (this.props.enableSelectFeaturesByPolygon) {
                        drawOptions.push(React.createElement(blocks_1.CtaButton, { key: drawOptions.length, label: `Select ${this.props.userFriendlyDescOfEntityBeingCaptured} Feature(s) By Area`, color: "primary", onClick: this.initiateSelectTemplateGeometryByPolygonDrawOperation.bind(this) }));
                    }
                }
                if (this.props.enableFeatureCaptureByDrawing) {
                    drawOptions.push(React.createElement(blocks_1.CtaButton, { key: drawOptions.length, label: `Draw ${this.props.userFriendlyDescOfEntityBeingCaptured} Feature(s) By ${this.props.geometryTypeToCapture.replace("Polygon", "Area")}`, color: "primary", onClick: this.initiateDrawGeometryOperation }));
                }
                return React.createElement(blocks_1.VGroup, null, drawOptions.map(x => {
                    return x;
                }));
            }
        }
    };
    exports.EntityCreateByGeometryView = EntityCreateByGeometryView = tslib_1.__decorate([
        (0, mobx_react_1.inject)(context => (0, StoreManager_1.injectStores)(context)),
        mobx_react_1.observer
    ], EntityCreateByGeometryView);
});
